var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgNuevaPropuesta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ECE7EA"
    },
    points: "0,0 0,432.356 56.889,455.111 79.645,512 348.016,512 348.016,0 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8B7E7F"
    },
    d: "M291.127,452.267h-73.274c-4.713,0-8.533-3.821-8.533-8.533s3.821-8.533,8.533-8.533h73.274 c4.713,0,8.533,3.821,8.533,8.533S295.84,452.267,291.127,452.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8B7E7F"
    },
    d: "M291.127,88.178H56.889c-4.713,0-8.533-3.821-8.533-8.533c0-4.713,3.821-8.533,8.533-8.533h234.238 c4.713,0,8.533,3.821,8.533,8.533C299.66,84.357,295.84,88.178,291.127,88.178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8B7E7F"
    },
    d: "M291.127,133.689H56.889c-4.713,0-8.533-3.821-8.533-8.533s3.821-8.533,8.533-8.533h234.238 c4.713,0,8.533,3.821,8.533,8.533S295.84,133.689,291.127,133.689z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8B7E7F"
    },
    d: "M291.127,179.2H56.889c-4.713,0-8.533-3.821-8.533-8.533s3.821-8.533,8.533-8.533h234.238 c4.713,0,8.533,3.821,8.533,8.533S295.84,179.2,291.127,179.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8B7E7F"
    },
    d: "M291.127,224.711H56.889c-4.713,0-8.533-3.821-8.533-8.533s3.821-8.533,8.533-8.533h234.238 c4.713,0,8.533,3.821,8.533,8.533S295.84,224.711,291.127,224.711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8B7E7F"
    },
    d: "M291.127,270.222H56.889c-4.713,0-8.533-3.821-8.533-8.533s3.821-8.533,8.533-8.533h234.238 c4.713,0,8.533,3.821,8.533,8.533S295.84,270.222,291.127,270.222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8B7E7F"
    },
    d: "M291.127,315.733H56.889c-4.713,0-8.533-3.821-8.533-8.533s3.821-8.533,8.533-8.533h234.238 c4.713,0,8.533,3.821,8.533,8.533S295.84,315.733,291.127,315.733z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C2B8B9"
    },
    points: "476.467,170.993 470.835,133.18 433.023,127.548 408.887,151.685 414.519,189.498  452.332,195.129 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#463836"
    },
    d: "M185.698,410.272c-2.221,2.221-2.221,5.824,0,8.045c2.222,2.222,5.824,2.221,8.045,0l35.446-20.87 l4.78-27.401l-27.401,4.78L185.698,410.272z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F99D88"
    },
    points: "236.384,324.188 206.568,374.826 229.19,397.447 279.828,367.632 274.197,329.819 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F14742"
    },
    d: "M503.016,144.443c11.977-11.977,11.979-31.466,0-43.445s-31.468-11.977-43.445,0l-26.55,26.55 l43.445,43.445L503.016,144.443z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.376,
    y: 228.941,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 771.4507 199.7752)",
    style: {
      fill: "#FFD24D"
    },
    width: 243.949,
    height: 61.439
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6CED1"
    },
    points: "0,432.356 79.645,512 79.645,432.356 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgNuevaPropuesta);
export default __webpack_public_path__ + "static/media/bg-nueva-propuesta.59a36646c4e3fd8309633946f8031f5a.svg";
export { ForwardRef as ReactComponent };